import { CustomAPI } from '@sydle/ui-api';
import type { FetchResponse, RestService } from '@sydle/ui-api';
import { OBJECT_LIST_API_CLASS_ID } from './constants';
import type { EObject, GroupedCards, SearchParams } from '../models';
import type {
  SavedSearch,
  SavedSearchData,
  SavedSearchReference,
} from '../components/views/one-object-list-view/object-list-view.types';
import type { CreateParams } from './object-api';

export type GetObjectCardsResponse = {
  groupedCards: GroupedCards[];
  hasDataGrouper?: boolean;
  total: number;
};

export type GetObjectCardsParams = {
  getCardsOptions: {
    classId: string;
    small?: boolean;
    ignoreObject?: string;
    ignoreGroups?: any[];
    storage?: any;
    fieldPath?: any;
    refSearchId?: any;
    timezoneId?: string;
    timeline?: boolean;
    tags?: boolean;
  };
  timezoneOffset: number;
  timezoneId: string;
  searchParams: SearchParams;
};

export type GetSearchesParams = { classId: string };
export type GetSearchesResponse = { savedSearches: SavedSearch[] };

export type CreateAdvancedSearchDraftParams = { classId: string; draftId?: string | undefined };
export type CreateAdvancedSearchDraftResponse = { draftId: string };

export type GetSavedSearchesParams = { searchClassId: string; viewId?: string; workspaceId?: string; slotId?: string };
export type GetSavedSearchesResponse = SavedSearchReference<SavedSearchData>[];

export type GetSavedSearchParams = { _id: string; searchClassId: string; data?: SavedSearchData };
export type GetSavedSearchResponse = SavedSearch;

export class ObjectListAPI {
  private api: CustomAPI;

  constructor(restService: RestService) {
    this.api = new CustomAPI(OBJECT_LIST_API_CLASS_ID, restService);
  }

  getObjectCards(params: GetObjectCardsParams): Promise<FetchResponse<GetObjectCardsResponse>> {
    return this.api.fetch('getObjectListCards', params);
  }

  getSearches(params: GetSearchesParams): Promise<FetchResponse<GetSearchesResponse>> {
    return this.api.fetch('getSearches', params);
  }

  createAdvancedSearchDraft(
    params: CreateAdvancedSearchDraftParams,
  ): Promise<FetchResponse<CreateAdvancedSearchDraftResponse>> {
    return this.api.fetch('createAdvancedSearchDraft', params);
  }

  getSavedSearches(params: GetSavedSearchesParams): Promise<FetchResponse<GetSavedSearchesResponse>> {
    return this.api.fetch('getSavedSearches', params);
  }

  getSavedSearch(params: GetSavedSearchParams): Promise<FetchResponse<GetSavedSearchResponse>> {
    return this.api.fetch('getSavedSearch', params);
  }

  createSavedSearch(params: CreateParams): Promise<FetchResponse<EObject>> {
    return this.api.fetch('createSavedSearch', params);
  }
}
